import Text from '../Text';

const Paragraph = Text.withComponent('p');
Paragraph.displayName = 'Paragraph';

export default Paragraph;
